import CompanyHeaderCard from "@/components/shared/AnonymousCompanyProfile/CompanyHeaderCard";
import AcceptInterestModal from "@/pages/interests/components/AcceptInterestModal";
import {
  useWorkspacePartnerHeader,
  WORKSPACE_PARTNER_BOOKMARK_BTN_STYLES,
} from "@/pages/collaborations/components/useWorkspacePartnerHeader";

export type WorkspacePartnerCompanyHeaderProps = {
  company: any;
  collaboration: any | null;
  onCollaborationChange: (collaboration: any | null) => void;
  showShortlist?: boolean;
  onExpressInterestClick?: () => void;
};

/** Compact partner header (GTID, anonymized contact, status chip, bookmark) for collaboration workspace. */
export default function WorkspacePartnerCompanyHeader({
  company,
  collaboration,
  onCollaborationChange,
  showShortlist = true,
  onExpressInterestClick,
}: WorkspacePartnerCompanyHeaderProps) {
  const {
    userCompanyId,
    isFavorited,
    headquartersFlagEmoji,
    canIncomingReceiverDownloadAnonymizedPdf,
    anonymizedPdfLoading,
    declineLoading,
    acceptModalOpened,
    acceptLoading,
    openAcceptModal,
    closeAcceptModal,
    handleShortlistClick,
    handleDownloadAnonymizedProfilePdf,
    handleAcceptConfirm,
    handleDecline,
  } = useWorkspacePartnerHeader({ company, collaboration, onCollaborationChange });

  return (
    <>
      <CompanyHeaderCard
        company={company}
        headquartersFlagEmoji={headquartersFlagEmoji}
        showProfileVerificationStepper={false}
        hideInterestCTA={false}
        disableShortlist={!showShortlist}
        isFavorited={isFavorited}
        collaborationStatus={collaboration}
        userCompanyId={userCompanyId}
        canIncomingReceiverDownloadAnonymizedPdf={canIncomingReceiverDownloadAnonymizedPdf}
        anonymizedPdfLoading={anonymizedPdfLoading}
        declineLoading={declineLoading}
        onExpressInterestClick={onExpressInterestClick ?? (() => undefined)}
        onShortlistClick={handleShortlistClick}
        onAcceptRequestClick={openAcceptModal}
        onDeclineClick={handleDecline}
        onDownloadAnonymizedProfilePdf={handleDownloadAnonymizedProfilePdf}
        bookmarkButtonStyles={WORKSPACE_PARTNER_BOOKMARK_BTN_STYLES}
        compactWorkspace
      />
      <AcceptInterestModal
        opened={acceptModalOpened}
        onClose={closeAcceptModal}
        onConfirm={handleAcceptConfirm}
        isLoading={acceptLoading}
      />
    </>
  );
}
